import { render } from "./ProjectCardFundsGather.vue?vue&type=template&id=55b492c2"
import script from "./ProjectCardFundsGather.vue?vue&type=script&lang=js"
export * from "./ProjectCardFundsGather.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__